function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M481.996 30.006C462.647 10.656 436.922 0 409.559 0s-53.089 10.656-72.438 30.005L50.826 316.301a20 20 0 00-5.125 8.779L.733 486.637a20 20 0 0024.732 24.601l161.557-45.891a20 20 0 008.699-33.359L93.869 329.827 331.184 92.511l88.258 88.258-181.674 181.179c-7.821 7.8-7.838 20.463-.038 28.284 7.799 7.822 20.464 7.838 28.284.039l215.98-215.392C501.344 155.53 512 129.805 512 102.442s-10.656-53.088-30.004-72.436zM143.395 436.158L48.827 463.02l26.485-95.152 68.083 68.29zM453.73 146.575l-5.965 5.949-88.296-88.297 5.938-5.938C377.2 46.495 392.88 40 409.559 40c16.679 0 32.358 6.495 44.152 18.29C465.505 70.083 472 85.763 472 102.442c0 16.679-6.495 32.359-18.27 44.133z"
});

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    className: "w-full h-full fill-current"
  }, props), _ref);
}

export default SvgEdit;